import { WeatherState } from './reducer'

export const weatherSelector = (state: { weather: WeatherState }) => 
    state.weather
